/**
 * DashboardEntry (Sprint 12+K, 07.07.2026).
 *
 * Auth-Guard-Entry-Point fuer `/dashboard`:
 *   - Noch nicht eingeloggt  → Login-Screen (30-Tage Magic-Link fuer Free-User)
 *   - Pionier                → Redirect zu /dashboard/pionier
 *   - Free-User mit Fokustyp → Redirect zu /cockpit
 *   - Free-User ohne Fokustyp→ Redirect zu /warteliste (Pre-Launch-Sicherer-Default)
 */
import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MagicLinkLoginForm } from "@/components/MagicLinkLoginForm";

export default function DashboardEntry() {
  const { user } = useAuth();

  // user === null → noch am Laden, false → nicht authentifiziert, object → eingeloggt
  if (user === null || typeof user === "undefined") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-400 text-sm">…</div>
      </div>
    );
  }

  if (user && typeof user === "object") {
    if (user.is_pionier) return <Navigate to="/dashboard/pionier" replace />;
    if (user.primary_fokustyp || user.fokustyp_primary) {
      return <Navigate to="/cockpit" replace />;
    }
    // Sprint M5.37 (29.07.2026) — Free-Launch: Eingeloggt ohne Fokustyp landet
    // im Cockpit (nicht mehr auf /warteliste — das war Pre-Launch-Default).
    return <Navigate to="/cockpit" replace />;
  }

  // Nicht eingeloggt → Free-User Magic-Link-Login
  return (
    <div className="min-h-screen bg-slate-50 py-12 sm:py-16 px-4">
      <div className="max-w-lg mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">
            Willkommen zurück.
          </h1>
          <p className="mt-3 text-slate-600">
            Melde dich mit deinem Login-Link an.
          </p>
        </div>

        <MagicLinkLoginForm
          flow="free"
          heading="Schon Nutzer:in?"
          hint="Ein Login-Link per E-Mail ist auf dem Weg (30 Tage gültig)."
          testIdPrefix="dashboard-login"
        />

        <div className="mt-6 text-center text-sm text-slate-500">
          Noch nicht dabei?{" "}
          <Link
            to="/warteliste"
            className="font-semibold text-[#4563BB] hover:underline"
            data-testid="dashboard-warteliste-link"
          >
            Auf die Warteliste
          </Link>
        </div>
      </div>
    </div>
  );
}
